import { createContext, ReactNode, useReducer } from 'react';
import { Module, MymeEditor, MymeEditorStep } from '@myme/utils/src/types';
import { initialState } from './initialState';
import { reducer } from './reducer';
import {
  CreateMymePayload,
  MymeEditorContext,
  MymeEditorContextValue,
  UpdateMymeDetailsPayload,
  UploadPreviewImagePayload
} from './types';

export const Context = createContext<MymeEditorContextValue | undefined>(undefined);

interface ProviderProps {
  children: ReactNode;
  mockedInitialState?: MymeEditorContext;
}

export const MymeEditorProvider = ({ children, mockedInitialState }: ProviderProps) => {
  const [state, dispatch] = useReducer(reducer, mockedInitialState || initialState);

  const switchStep = (step: MymeEditorStep) => {
    dispatch({ type: 'SWITCH_STEP', payload: { step } });
  };

  const dispatchSetRedirect = (redirect: string) => {
    dispatch({ type: 'SET_REDIRECT', payload: redirect });
  };

  const dispatchClearRedirect = () => {
    dispatch({ type: 'CLEAR_REDIRECT' });
  };

  const dispatchSetInitialMymeData = (myme: MymeEditor) => {
    dispatch({ type: 'SET_INITIAL_INTEREST_DATA', payload: myme });
  };

  const dispatchCreateMyme = (myme: CreateMymePayload) => {
    dispatch({ type: 'CREATE_INTREST', payload: myme });
  };

  const dispatchUpdateMymeDetails = (mymeDetails: UpdateMymeDetailsPayload) => {
    dispatch({ type: 'UPDATE_INTREST_DETAILS', payload: mymeDetails });
  };

  const dispatchUploadPreviewImage = (mymePreviewImage: UploadPreviewImagePayload) => {
    dispatch({ type: 'UPLOAD_PREVIEW_IMAGE', payload: mymePreviewImage });
  };

  const dispatchUpdateMymeContent = (modules: Module[]) => {
    dispatch({ type: 'SET_MODULES', payload: modules });
  };

  const dispatchDeleteOnUnmountInCreator = () => {
    if (state.isCreator) {
      dispatch({ type: 'DELETE_ON_UNMOUNT' });
    }
  };

  const dispatchClearMymeEditor = () => {
    dispatch({ type: 'RESET_INTREST_EDITOR' });
  };

  return (
    <Context.Provider
      value={{
        editor: state,
        switchStep,
        dispatchSetRedirect,
        dispatchClearRedirect,
        dispatchSetInitialMymeData,
        dispatchCreateMyme,
        dispatchUpdateMymeDetails,
        dispatchUploadPreviewImage,
        dispatchUpdateMymeContent,
        dispatchDeleteOnUnmountInCreator,
        dispatchClearMymeEditor
      }}
    >
      {children}
    </Context.Provider>
  );
};
